'use client';

import { useMemo, useCallback, useState } from 'react';
import { usePathname } from 'next/navigation';
import { Icon, Text } from '@weareconceptstudio/core';

//* Components
import CustomLink from '../CustomLink';

//* Styles
import ShareStyle from './style';

const Share = ({ className = '', inline = false }) => {
	//! Next Navigation
	const pathname = usePathname();

	const url = useMemo(() => process.env.NEXT_PUBLIC_URL + pathname, [pathname]);

	const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
	const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
	const twitterUrl = `https://twitter.com/intent/tweet?url=${url}`;
	const telegramUrl = `https://t.me/share/url?url=${url}`;

	const [clipboardTextShowMessage, setClipboardTextShowMessage] = useState(false);

	const handleCopyToClipboard = useCallback(
		(e) => {
			e.preventDefault();
			e.stopPropagation();

			if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard
					.writeText(url)
					.then(() => {
						setClipboardTextShowMessage(true);

						setTimeout(() => {
							setClipboardTextShowMessage(false);
						}, 1000);
					})
					.catch((err) => {
						// console.error('Failed to copy via Clipboard API: ', err);
					});
				return;
			}

			if (typeof document !== 'undefined') {
				const textArea = document.createElement('textarea');
				textArea.value = url;
				textArea.style.position = 'fixed';
				textArea.style.top = '0';
				textArea.style.left = '0';
				textArea.style.opacity = '0';

				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();

				try {
					const successful = document.execCommand('copy');
					if (successful) {
						// alert('Link copied to clipboard!');

						setClipboardTextShowMessage(true);

						setTimeout(() => {
							setClipboardTextShowMessage(false);
						}, 1000);
					} else {
						// console.error('Fallback: execCommand copy was unsuccessful');
					}
				} catch (err) {
					// console.error('Fallback: unable to copy', err);
				} finally {
					document.body.removeChild(textArea);
				}
			}
		},
		[url]
	);

	return (
		<ShareStyle
			className={`share-wrapper ${className}`}
			$inline={inline}>
			<CustomLink
				external
				url={facebookUrl}
				className={'fb-icon'}>
				<Icon
					className={'h6 media-share'}
					name={'facebook'}
				/>
			</CustomLink>

			<CustomLink
				external
				url={linkedinUrl}
				className={'linkedin-icon'}>
				<Icon
					className={'h6 media-share'}
					name={'linkedin'}
				/>
			</CustomLink>

			<CustomLink
				external
				url={telegramUrl}
				className={'linkedin-icon'}>
				<Icon
					className={'h6 media-share'}
					name={'telegram'}
				/>
			</CustomLink>

			<CustomLink
				external
				url={twitterUrl}
				className={'x-icon'}>
				<Icon
					className={'h6 media-share'}
					name={'new-twitter'}
				/>
			</CustomLink>

			<div
				onClick={(e) => {
					handleCopyToClipboard(e);
				}}
				className={'link-icon link-item link-copy-icon'}
				role='button'>
				<Icon
					className={'h6 media-share'}
					name={'copy'}
				/>
				{clipboardTextShowMessage ? (
					<div className='clipboard-text-message'>
						<Text
							className='p p2 montserrat-400 black-1000'
							text='copied'
						/>
					</div>
				) : null}
			</div>
		</ShareStyle>
	);
};

export default Share;
